import { PropsWithChildren } from 'react';

import { Typography } from '@cast/design-system';

export const ClusterDialogTitle = (props: PropsWithChildren) => {
  return <Typography variant="h5">{props.children}</Typography>;
};
